import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';

export var IntegrationRuns = {
	
	manageRuns(record) {
		var runWin = ElementUtil.create({
			tag: 'dl-dialog',
			title: 'Runs',
			icon: 'vaadin:play',
			width: .75,
			height: .75,
			listeners: {
				ready: function () {
					runWin.show();

					var runTools = ElementUtil.create({
						tag: 'dl-toolbar',
						slot: 'toolbar',
						theme: 'spacing',
						children: [
							{
								tag: 'dl-action-button',
								'class': 'spacer-toolbar-item',
								permissions: ['ADMIN_INTEGRATIONS:READ', 'INTEGRATIONS:READ'],
								children: [
									ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
								],
								listeners: {
									click: function () {
										actionLoadRuns();
									}
								}
							},
							{
								tag: 'span',
								innerHTML: '|'
							},
							{
								tag: 'dl-action-button',
								itemid: 'add',
								theme: 'primary',
								'class': 'spacer-toolbar-item',
								permissions: ['ADMIN_INTEGRATIONS:EXECUTE', 'INTEGRATIONS:EXECUTE'],
								children: [
									ElementUtil.makeIcon('vaadin:play', ' Run')
								],
								listeners: {
									click: function () {
										actionRun();
									}
								}
							},
							{
								tag: 'dl-action-button',
								itemid: 'details',
								'class': 'spacer-toolbar-item',
								permissions: ['ADMIN_INTEGRATIONS:READ', 'INTEGRATIONS:READ'],
								children: [
									ElementUtil.makeIcon('vaadin:modal-list', ' Details')
								],
								listeners: {
									click: function () {
										actionShowRunDetails(runGrid.selectedItems[0]);
									}
								}
							}
						]
					});

					var runGrid = ElementUtil.create({
						tag: 'vaadin-grid',
						theme: 'row-stripes column-borders',
						'column-reordering-allowed': '',
						style: 'height: 100%;',
						slot: 'primary',
						defaults: {
							tag: 'vaadin-grid-sort-column',
							resizable: true
						},
						children: [
							{
								path: 'runStatusDescription',
								header: 'Run Status',
								width: '14em',
								renderer: function (root, column, rowData) {
									root.innerHTML = '';
									var run = rowData.item;
									var status = run.runStatus;
									var description = run.runStatusDescription || '';
									var wrapper = document.createElement('span');
									wrapper.style.display = 'inline-flex';
									wrapper.style.alignItems = 'center';
									wrapper.style.gap = '0.35em';

									var icon = document.createElement('vaadin-icon');
									var iconName = 'vaadin:warning';
									var iconColor = 'var(--lumo-warning-color)';
									if (status === 'FAILURE') {
										iconName = 'vaadin:close-circle';
										iconColor = 'var(--lumo-error-color)';
									} else if (status === 'SUCCESS' || status === 'COMPLETE') {
										iconName = 'vaadin:check-circle';
										iconColor = 'var(--lumo-success-color)';
									} else if (status === 'NODE_INTERRUPTED') {
										iconName = 'vaadin:minus-circle';
										iconColor = 'var(--lumo-contrast-60pct)';
									} else if (status === 'WORKING' || status === 'QUEUED') {
										iconName = 'vaadin:exchange';
										iconColor = 'var(--lumo-primary-color)';
									}
									icon.setAttribute('icon', iconName);
									icon.style.color = iconColor;
									wrapper.appendChild(icon);
									wrapper.appendChild(document.createTextNode(description));
									root.appendChild(wrapper);
								}
							},
							{
								path: 'diagnosticMode',
								header: 'Diagnostic Mode',
								'text-align': 'center',
								width: '7em'
							},
							{
								path: 'manualRun',
								header: 'Manual Run',
								'text-align': 'center',
								width: '7em'
							},
							{
								path: 'skipChecks',
								header: 'Skip Checks',
								'text-align': 'center',
								width: '7em'
							},
							{
								path: 'runDate',
								header: 'Run Date',
								width: '7em',
								renderer: function (root, column, rowData) {
									root.innerHTML = TimeUtil.formatDateStandard(rowData.item.runDate);
								}
							},
							{
								path: 'latestDataDate',
								header: 'Latest Data Date',
								width: '7em',
								renderer: function (root, column, rowData) {
									root.innerHTML = TimeUtil.formatDateStandard(rowData.item.latestDataDate);
								}
							},
							{
								path: 'runDate',
								header: 'Run Time',
								width: '7em',
								renderer: function (root, column, rowData) {
									var startDate = TimeUtil.parseDate(rowData.item.runDate);
									var completeDate = TimeUtil.parseDate(rowData.item.completeDate);

									var runtime = '-:-:-';
									if (rowData.item.runStatus === 'CANCELED') {
										runtime = 'N/A'
									} else {
										if (startDate && completeDate) {
											var millis = completeDate.getTime() - startDate.getTime();
											runtime = TimeUtil.milliToDisplay(millis);
										} else if (startDate) {
											var millis = (new Date()).getTime() - startDate.getTime();
											runtime = TimeUtil.milliToDisplay(millis);
										}
									}
									root.innerHTML = runtime;
								}
							}
						],
						listeners: {
							'active-item-changed': function (event) {
								const item = event.detail.value;
								runGrid.selectedItems = item ? [item] : [];

								if (runGrid.selectedItems.length > 0) {
									ElementUtil.query(runTools, 'details').disabled = false;
								} else {
									ElementUtil.query(runTools, 'details').disabled = true;
								}
							}
						}
					});

					var layout = ElementUtil.create({
						tag: 'dl-flex-layout',
						children: [
							runTools,
							runGrid
						]
					});

					runWin.addToContentElement(layout);

					var actionLoadRuns = function () {
						var loadMask = runGrid.showLoading();
						DataManagementService.getIntegrationService().getIntegrationRuns(record.configId).then(function (runs) {
							loadMask.remove();
							runGrid.activeItem = null;
							runGrid.items = runs;
						});
					};
					actionLoadRuns();

					var actionRun = function () {

						var addEditWin = ElementUtil.create({
							tag: 'dl-dialog',
							title: 'Run',
							icon: 'vaadin:play',
							width: 500,
							height: 300,
							listeners: {
								ready: function () {
									addEditWin.show();

									var formPanel = ElementUtil.create({
										tag: 'dl-form-panel',
										itemid: 'form',
										children: [
											{
												tag: 'vaadin-form-layout',
												children: [
													{
														tag: 'vaadin-checkbox',
														name: 'diagnosticMode',
														label: 'Diagnostic Mode'
													},
													{
														tag: 'vaadin-checkbox',
														name: 'skipChecks',
														label: 'Skip Checks (Lock and Run Checks)'
													},
													{
														tag: 'hr',
														colspan: 2
													},
													{
														tag: 'div',
														style: 'text-align: center;',
														colspan: 2,
														defaults: {
															tag: 'vaadin-button'
														},
														children: [
															{
																theme: 'primary',
																children: [
																	ElementUtil.makeIcon('vaadin:database', ' Run')
																],
																listeners: {
																	click: function () {

																		formPanel.submitForm({
																			preSubmit: function (data) {
																				return data;
																			},
																			actualCall: function (data) {
																				if (record) {
																					data.configId = record.configId;
																				}
																				return DataManagementService.getIntegrationService().submitRun(record.configId, data);
																			},
																			success: function (data, responseData) {
																				window.DL.MessageUtil.showToast('Success', 'Submitted Run', {
																					theme: 'success',
																					position: 'top-stretch'
																				});
																				if (formPanel.successCallback) {
																					formPanel.successCallback();
																				}
																				actionLoadRuns();
																				addEditWin.close();
																			},
																			fail: function (data, responseData) {
																				var skipReason = responseData && responseData.errors && responseData.errors.skipChecks
																					? responseData.errors.skipChecks
																					: 'The run was not started.';
																				window.DL.MessageUtil.showOkMessage(
																					skipReason + '<br><br>Enable <b>Skip Checks</b> to run anyway.',
																					null,
																					{title: 'Run Not Started'}
																				);
																			}
																		});

																	}
																}
															},
															{
																theme: 'tertiary',
																innerHTML: 'Cancel',
																style: 'margin-left: 10px;',
																listeners: {
																	click: function () {
																		//cancel
																		addEditWin.close();
																	}
																}
															}
														]
													}
												]
											}
										]

									});
									addEditWin.addToContentElement(formPanel);

								}
							}
						});
					};

					var actionShowRunDetails = function (run) {

						var detailWin = ElementUtil.create({
							tag: 'dl-dialog',
							title: 'Details',
							icon: 'vaadin:modal-list',
							width: .75,
							height: .75,
							listeners: {
								ready: function () {
									detailWin.show();


									var detailTable = ElementUtil.create({
										tag: 'dl-detail-table',
										itemid: 'detailtable',
										slot: 'primary'
									});

									var data = [
										{
											key: 'Integration Details',
											value: '-',
											section: true
										},
										{
											key: 'Run Id',
											value: run.integrationRunId
										},
										{
											key: 'Run Status',
											value: run.runStatusDescription || run.runStatus
										},
										{
											key: 'Diagnostic Mode',
											value: run.diagnosticMode
										},
										{
											key: 'Manual Run',
											value: run.manualRun
										},
										{
											key: 'Skip Checks',
											value: run.skipChecks
										},
										{
											key: 'Run Date',
											value: run.runDate ? TimeUtil.formatDateStandard(run.runDate) : "N/A"
										},
										{
											key: 'Queue Time',
											value: (function() {
												if (run.runStatus === 'QUEUED' && run.runDate) {
													var elapsed = Date.now() - new Date(run.runDate).getTime();
													return TimeUtil.milliToDisplay(elapsed);
												}
												if (run.queueTimeMillis !== null && run.queueTimeMillis !== undefined) {
													return TimeUtil.milliToDisplay(run.queueTimeMillis);
												}
												return 'N/A';
											})()
										},
										{
											key: 'latest Data Date',
											value: run.latestDataDate ? TimeUtil.formatDateStandard(run.latestDataDate) : "N/A"
										},
										{
											key: 'Complete Date',
											value: run.completeDate ? TimeUtil.formatDateStandard(run.completeDate) : "N/A"
										}
									];

									if (run.integrationRunReceipt) {
										data.push({
											key: 'Run Receipt',
											value: '-',
											section: true
										});
										data.push({
											key: 'Name',
											value: run.integrationRunReceipt.name
										});
										data.push({
											key: 'Transmit Date',
											value: run.completeDate ? TimeUtil.formatDateStandard(run.completeDate) : "N/A"
										});
										data.push({
											key: 'Receipt Data',
											value: run.integrationRunReceipt.receiptData
										});
									}

									if (run.messages) {
										data.push({
											key: 'Messages',
											value: '-',
											section: true
										});

										run.messages.forEach(function (message) {
											data.push({
												key: 'Log',
												value: message.level + ' - ' + message.message
											});	
											if (message.trace) {
												data.push({
													key: 'Trace',
													value: message.trace
												});
											}
										});
									}

									if (run.unitsToRun) {
										data.push({
											key: 'Units Ran',
											value: '-',
											section: true
										});

										run.unitsToRun.forEach(function (unit) {
											data.push({
												key: 'Reference Type',
												value: unit.referenceType
											});
											data.push({
												key: 'External Id',
												value: unit.externalId
											});
											data.push({
												key: 'External Ref No',
												value: unit.externalRefNo
											});
											data.push({
												key: 'Begin Dts',
												value: unit.beginDts ? TimeUtil.formatDateStandard(unit.beginDts) : "N/A"
											});
											data.push({
												key: 'End Dts',
												value: unit.endDts ? TimeUtil.formatDateStandard(unit.endDts) : "N/A"
											});
										});
									}

									detailTable.updateDetails(data);

									var layout = ElementUtil.create({
										tag: 'dl-flex-layout',
										children: [
											detailTable
										]
									});

									detailWin.addToContentElement(layout);

								}
							}
						});

					};
				}
			}
		});
	},
	
	backPull(record) {
		
		var backpullWin = ElementUtil.create({
			tag: 'dl-dialog',
			title: 'Runs',
			icon: 'vaadin:play',
			width: .75,
			height: 400,
			listeners: {
				ready: function () {
					backpullWin.show();
					
					var formPanel = ElementUtil.create({
						tag: 'dl-form-panel',
						itemid: 'form',
						children: [
							{
								tag: 'vaadin-form-layout',
								children: [
									{
										tag: 'vaadin-date-time-picker',
										label: 'Start Date (mm/dd/yyyy hh:mm:ss)',
										name: 'startDts',
										step: 1,
										value: TimeUtil.formatDateForDateLoad(new Date()) + 'T00:00:00',
										required: true
									},
									{
										tag: 'vaadin-date-time-picker',
										label: 'End Date (mm/dd/yyyy hh:mm:ss)',
										name: 'endDts',
										step: 1,
										value: TimeUtil.formatDateForDateLoad(new Date()) + 'T23:59:59',
										required: true
									},
									{
										tag: 'vaadin-number-field',										
										name: 'chunkMinutes',
										label: 'Chunk Minutes',										
										required: true,
										value: 1440,										
										min: 1,
										max: 10080											
									},
									{
										tag: 'vaadin-number-field',										
										name: 'maxRecordsPerBatch',
										label: 'Minimum Records Per Batch',	
										required: true,
										value: 250000,
										min: 1,
										max: 1000000										
									},
									
									{
										tag: 'vaadin-text-field',										
										name: 'unitList',
										label: 'Unit List',
										style: (record.backPullUnits ? '' : 'display: none;'),
										maxLength: 4096											
									},
									{
										tag: 'hr',
										colspan: 2
									},
									{
										tag: 'div',
										style: 'text-align: center;',
										colspan: 2,
										defaults: {
											tag: 'vaadin-button'
										},
										children: [
											{
												theme: 'primary',
												children: [
													ElementUtil.makeIcon('vaadin:arrow-circle-right-o', ' Proceed')
												],
												listeners: {
													click: function () {

														formPanel.submitForm({
															preSubmit: function (data) {																
																return data;
															},
															actualCall: function (data) {
																if (record) {
																	data.configId = record.configId;
																}
																return DataManagementService.getIntegrationService().backPull(data.configId, data);
															},
															success: function (data, responseData) {
																window.DL.MessageUtil.showToast('Success', 'Submitted Backpull Request. <br>Watch for notification of completion.', {
																	theme: 'success',
																	position: 'top-stretch'
																});														
																backpullWin.close();
															}
														});
														
													}
												}
											},
											{
												theme: 'tertiary',
												innerHTML: 'Cancel',
												style: 'margin-left: 10px;',
												listeners: {
													click: function () {
														//cancel
														backpullWin.close();
													}
												}
											}
										]
									}
								]
							}								
						]
					});
					backpullWin.addToContentElement(formPanel);					
					
				}
			}
		});
		
	}
	
};

